import { useParams } from "react-router-dom";
import { useGetSpectrumFeaturesQuery } from "../spectraSlice";
import useLang from "../../../hooks/useLang";

const useSpectrumFeaturesByLabelBlock = ({ editing }) => {
  const { spectrumId } = useParams();
  const lang = useLang();
  const skip = spectrumId == null;
  const { data: positive, isFetching: isFetchingPositive } =
    useGetSpectrumFeaturesQuery({ id: spectrumId, label: "positive" }, { skip });
  const { data: negative, isFetching: isFetchingNegative } =
    useGetSpectrumFeaturesQuery({ id: spectrumId, label: "negative" }, { skip });
  const { data: unassigned, isFetching: isFetchingUnassigned } =
    useGetSpectrumFeaturesQuery(
      { id: spectrumId, label: "unassigned" },
      { skip }
    );

  if (isFetchingPositive || isFetchingNegative || isFetchingUnassigned) {
    return [
      {
        id: "loading",
        label: false,
        value: lang("features.features_loading"),
      },
    ];
  }

  return [
    {
      id: "featuresByLabel",
      type: "featuresByLabel",
      positive: positive || [],
      negative: negative || [],
      unassigned: unassigned || [],
      editing: Boolean(editing),
    },
  ];
};

export default useSpectrumFeaturesByLabelBlock;
